import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalido?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { className, invalido, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalido || undefined}
      className={cn(
        'w-full rounded-[var(--radius-md)] border border-[var(--cor-borda-forte)] bg-[var(--cor-superficie)]',
        'px-3 py-2.5 text-base text-[var(--cor-texto)] sm:text-sm',
        'placeholder:text-[var(--cor-texto-fraco)]',
        'focus:border-[var(--brand)] focus:outline-none focus:ring-2 focus:ring-[var(--brand)]/20',
        invalido && 'border-[var(--status-recusado)] focus:ring-[var(--status-recusado)]/20',
        className,
      )}
      {...props}
    />
  );
});
